export enum WidgetName {
  JDO = 'JDO',
  YOUR_TENDER = 'YOUR_TENDER',
  SIMULATION = 'SIMULATION',
  DEBT_SUMMARY = 'DEBT_SUMMARY',
  DEBT_MONTHLY_PAYMENTS = 'DEBT_MONTHLY_PAYMENTS',
  EPARGNE_DE_GESTION = 'EPARGNE_DE_GESTION',
  FOND_DE_ROULEMENT_FIN_EXERCICE = 'FOND_DE_ROULEMENT_FIN_EXERCICE',
  NIVEAU_DES_EPARGNES = 'NIVEAU_DES_EPARGNES',
  RATIO_DE_DESENDETTEMENT = 'RATIO_DE_DESENDETTEMENT',
  GUARANTY = 'GUARANTY',
  SCENARIOS_PARTAGES = 'SCENARIOS_PARTAGES',
  LATEST_VIDEOS = 'LATEST_VIDEOS',
  LATEST_ARTICLES = 'LATEST_ARTICLES',
  DEDICATED_CONSULTANT = 'DEDICATED_CONSULTANT',
  LATEST_EVENTS = 'LATEST_EVENTS',
}

export const INVISEO_VARIABLE_WIDGETS = [
  WidgetName.EPARGNE_DE_GESTION,
  WidgetName.FOND_DE_ROULEMENT_FIN_EXERCICE,
  WidgetName.NIVEAU_DES_EPARGNES,
  WidgetName.RATIO_DE_DESENDETTEMENT
];
